import Head from 'next/head'
import { useRouter } from 'next/router';
import Link from "next/link";
import { NavBottom } from '../components/nav';
export default function NotFound() {
  const router = useRouter();
  const incorrectFR = router.asPath;
  const correctFR   = incorrectFR.replace(`/fr/`, `/`);
  return (
    <div className="raqtaq">
      <Head>
        <title>404</title>
        <meta name='description' content='Qui est raqtaq et quelle est sa mission ?' />
        <link rel="icon" href="../favicon.ico" />
      </Head>
      <main className='contenu'>
      <div className='contenu-body'>
        <div><h1>Erreur 404 Error</h1></div>
        <div className="homeUneCardPix" style={{backgroundImage: `url('https://sunulife.com/404.webp')`}}></div>
          <p><br></br>
            Page non disponible / Unavailable page.
          </p>
      </div>
      </main>

      <footer>
                <NavBottom />
      </footer>

    </div>
  )
}